<template>
    <div class="t-page_about t-work-area">
        <h1>{{ pageText.title }}</h1>
        <div class="t-work-area__row">
            <div class="t-work-area__column_big">
                <div class="t-work-area__cell t-default" v-html="about"></div>
            </div>
        </div>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/aboutPage.json' : 'staticText',
        main: {
            title: "О сервисе",
        }
    };

    import {store} from '../../store'
    import {mapActions} from 'vuex';
    import Vue from 'vue'

		export default {
				data(){
						return{
                pageText: {},
                about: null
						}
				},
				methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText, about){
                this.pageText = pageText;
                this.about = about;

                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
				},
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
				beforeRouteEnter (to, from, next) {
						let count = 0;

						let about = '',
            		pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

						Vue.http.get('about.json')
								.then(response => response.json())
								.then(data => {
                    about = data.text;
										count++;
										RunNext();
								});

						let RunNext = () => {
								if(count > 1)
										next(vm => vm.Load(pageText, about))
						}
				}
		}
</script>


// WEBPACK FOOTER //
// src/vue_pages/About/Index.vue